export const PROJECT_DEFINITION_REDUCER_KEY = "projectDefinition";
export const SELECT_PAGES_REDUCER_KEY = "selectPages";
export const SELECT_CTAS_REDUCER_KEY = "pickCtas";
export const SELECT_AUDIENCE_REDUCER_KEY = "pickAudience";
export const LAUNCH_PROJECT_REDUCER_KEY = "launchProject";

export const AUDIENCE_OPEN_QUOTAS = "openQuotas";
export const AUDIENCE_IN_FLIGHT_REQUESTS = "inFlightRequests";



// WEBPACK FOOTER //
// ./src/modules/configure-wevo/constants.js